import DataTable from '@/common/tableData/DataTable';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import CurrencyDisplay from '@/components/common/CurrencyDisplay';
import routes from '@/routes/routes-enums';

import useTournamentDetails from '@/hooks/useTournamentDetails';
import { TicketType, TournamentStatus } from '@repo/common-types';
import { ColumnFilter } from '@tanstack/react-table';

const TournamentPlayersTable = () => {
  const { tournamentId } = useParams();

  const { tournament, players } = useTournamentDetails(tournamentId ?? '');

  const [columnFilters, setColumnFilters] = useState<ColumnFilter[]>([]);

  const handlePlayerSearch = (value: string | number) => {
    setColumnFilters((filters) => {
      const newFilters = filters.filter((filter) => filter.id !== 'alias');
      const existingAliasFilter = filters.find((filter) => filter.id === 'alias');
      if (existingAliasFilter && value !== '') {
        return [
          ...newFilters,
          {
            id: 'alias',
            value: value,
          },
        ];
      }

      if (existingAliasFilter && value === '') {
        return newFilters;
      }

      if (!existingAliasFilter && value !== '') {
        return [
          ...newFilters,
          {
            id: 'alias',
            value: value,
          },
        ];
      }

      return filters;
    });
  };

  return (
    <DataTable
      title={`Players`}
      data={players?.players ?? []}
      onSearch={handlePlayerSearch}
      columnFilters={columnFilters}
      columns={[
        {
          header: 'Alias',
          accessorKey: 'alias',
          size: 150,
          cell: ({ row }) => {
            return (
              <Link className="text-decoration-underline" to={`${routes.USER_EDIT}/${row.original.userId}`}>
                {row.original.alias}
              </Link>
            );
          },
        },
        {
          header: 'Table',
          accessorKey: 'tableId',
        },
        {
          header: 'Status',
          accessorKey: 'isEliminated',
          cell: ({ row }) => {
            if (tournament?.status === TournamentStatus.COMPLETED) {
              return 'Completed';
            }
            return row.original.isEliminated ? 'Eliminated' : 'Active';
          },
        },
        {
          header: 'Stack',
          accessorKey: 'chips',
        },
        {
          header: 'Position',
          accessorKey: 'rank',
          cell: (cell) => {
            const place = cell.getValue();
            return place ? place : '-';
          },
        },
        {
          header: 'Payment Amount',
          accessorKey: 'prizeAwarded',
          size: 200,
          cell: ({ row }) => (
            <CurrencyDisplay amount={row.original.prizeAwarded ?? 0} ticketType={row.original.ticketType} />
          ),
        },
      ]}
    />
  );
};

export default TournamentPlayersTable;
